import updateNavigationBarWidth from '../services/updateNavigationBarWidth';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';

/**
 * Sets the folder pane width in the local user config and makes a call to update it in server userConfig
 * @param newFolderPaneWidth the width of navigation pane
 */
export default action('setFolderPaneWidth')(function setFolderPaneWidth(
    newFolderPaneWidth: number
) {
    const storedFolderPaneWidth = getUserConfiguration().UserOptions.NavigationBarWidth;

    // Width did not change
    if (storedFolderPaneWidth == newFolderPaneWidth) {
        return;
    }

    /* Update in local user config */
    getUserConfiguration().UserOptions.NavigationBarWidth = newFolderPaneWidth;

    /* Make server call to update server user-config */
    updateNavigationBarWidth(newFolderPaneWidth);
});
